import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useSteps } from '../../../../hooks/use-steps.js';
import ConfiguratorStepTitleAndDescription from './ConfiguratorStepTitleAndDescription.js';

const ConfiguratorStepTitleAndDescriptionContainer = ({ textAlignment , titleClassName , descriptionClassName ,  })=>{
    const { getLabel , getFormattedLabel , hasLabel  } = useIntl();
    const { currentStep  } = useSteps();
    const { title , description  } = currentStep.labelKeys;
    const labels = React__default.useMemo(()=>({
            title: getLabel(title),
            description: description && hasLabel(description) ? getFormattedLabel(description, {
                parseLink: true,
                openLinksInNewTab: true,
                hideLabelKey: true
            }) : undefined
        })
    , [
        getLabel,
        title,
        description,
        getFormattedLabel,
        hasLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(ConfiguratorStepTitleAndDescription, swcHelpers.extends({}, labels, {
        textAlignment: textAlignment,
        titleClassName: titleClassName,
        descriptionClassName: descriptionClassName
    }));
};
var ConfiguratorStepTitleAndDescriptionContainer$1 = ConfiguratorStepTitleAndDescriptionContainer;

export { ConfiguratorStepTitleAndDescriptionContainer$1 as default };
//# sourceMappingURL=ConfiguratorStepTitleAndDescriptionContainer.js.map
